module.exports = __webpack_public_path__ + "img/2fe13495a3791ade7bd2d7b66108397f.png";